import React from 'react';
import {Badge} from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => {
    return {
        root:{
            "&.tertiary .MuiBadge-badge":{
                backgroundColor: theme.palette.tertiary.main,
                color: theme.palette.tertiary.contrastText,
            },
            "&.quaternary .MuiBadge-badge":{
                backgroundColor: theme.palette.quaternary.main,
                color: theme.palette.quaternary.contrastText,
            },
            "&.gray .MuiBadge-badge":{
                backgroundColor: theme.palette.gray.main,
                color: theme.palette.gray.contrastText,
            }
        },
    };
};

const allowedColors = ['primary', 'secondary', 'success', 'info', 'warning'];
export const MuiBadge = withStyles(styles)((props) => {
    //const { className, color, ...rest } = props;
    const { className, color } = props;
    return <Badge
                    {...props}
                   color={allowedColors.includes(color) ? color : "primary"}
                   className={(allowedColors.includes(color) ? '' : color) + ` ${className} `}
    />
});